// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { finishSsoPopupIfLanded } from "./ssoPopup";

function mountApp() {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

// Se a janelinha está fechando, não vale a pena montar o app nela.
if (!finishSsoPopupIfLanded()) {
  mountApp();
}

reportWebVitals();
